import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tagType), {
    for: _ctx.labelFor,
    class: _normalizeClass(["label", {
      'label--disabled': _ctx.disabled,
      'label--required': _ctx.required,
      [`label--size-${_ctx.size}`]: _ctx.size,
    }])
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["for", "class"]))
}